<div>
  <span class="font-weight-600">
      {{title}}:
  </span>
  <span  nzTooltipTitle="Copy link" nzTooltipPlacement="top" nz-button nz-tooltip class="app-link" #text (click)="copyToClipboardWithParameter(text)">
    {{api}}
  </span> 
</div>